<script setup lang="ts">
import { useContainers } from '@/composables/rc/containers'
import { ContainerStatus, type IContainerDashboard } from '@/types/rc/containers'
import type { IContainerDashboardFilters } from '@/types/rc/filters'
import { ShipmentType } from '@/types/rc/shipments'
import { computed, reactive, ref } from 'vue'
import type { TableInstance } from 'element-plus'

const selectable = (row: IContainerDashboard) => !!row.assigned_miners

const props = withDefaults(defineProps<{ workOrderNumber?: string; disabled?: boolean }>(), { disabled: false })
const containersSelected = defineModel<IContainerDashboard[]>({ required: true })

const onSelect = (containers: IContainerDashboard[]) => {
  containersSelected.value = containers
}

const filters = reactive<IContainerDashboardFilters>({
  page: 1,
  per_page: 100,
  work_order_number: props.workOrderNumber,
  kind: ShipmentType.Outbound,
  status: ContainerStatus.ReadyForBilling,
  invoiced: false,
})

const { getContainersQuery } = useContainers()
const { data: queryResponse, isFetching: containersSearchLoading } = getContainersQuery(filters)

const containerOptions = computed(() => queryResponse.value?.data ?? [])

const tableRef = ref<TableInstance>()
const clearSelection = () => {
  tableRef.value?.clearSelection()
}
defineExpose({ clearSelection })
</script>

<template>
  <el-table
    ref="tableRef"
    :data="containerOptions"
    :loading="containersSearchLoading"
    :highlight-current-row="false"
    @selection-change="onSelect"
  >
    <el-table-column type="selection" width="55" :selectable="selectable" />
    <el-table-column prop="number" label="Container #" width="240" />
    <el-table-column prop="type" label="Container #" width="120" />
    <el-table-column prop="miners" label="Miners" width="90">
      <template #default="{ row }"> {{ row.assigned_miners }}/{{ row.expected_miners }} </template>
    </el-table-column>
  </el-table>
</template>

<style scoped lang="scss">
:deep() {
  .el-table {
    &__cell {
      background-color: var(--fill-secondary);

      &.is-leaf {
        background-color: var(--fill-secondary);
      }
    }
  }
}
</style>
